import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef, inject, Renderer2 } from '@angular/core';
import { LocalFacade, LocalState } from '@common/localstate/frontend-shared';
import { AccessState } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { dayjs } from '@core/shared/utils/dayjs';
import { UiButtonComponent } from '../button';
import { UiIconsModule } from '../icons';
import { UiTooltipContentComponent, TooltipPlacements } from '../tooltip';
import * as i0 from "@angular/core";
import * as i1 from "@common/localstate/frontend-shared";
import * as i2 from "@ngxs/store";
import * as i3 from "@angular/common";
import * as i4 from "../icons/icon.component";
import * as i5 from "../tooltip/tooltip-content.component";
import * as i6 from "../tooltip/tooltip.directive";
const _c0 = ["wrapper"];
const _c1 = ["border"];
const _c2 = ["content"];
const _c3 = ["infoBox"];
const _c4 = ["tooltipFeatureInfo"];
const _c5 = ["*"];
const _c6 = () => ({
  mainAxis: 20,
  crossAxis: 6
});
const _c7 = (a0, a1) => ({
  hideOnScroll: true,
  hideDelay: 0,
  placement: a0,
  offset: a1
});
const _c8 = () => ({
  trigger: "click"
});
function UiFeatureHighlightComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "ui-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const tooltipFeatureInfo_r2 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngClass", "position-" + ctx_r0.position)("uiTooltipTrigger", tooltipFeatureInfo_r2)("uiTooltipTriggerOptions", i0.ɵɵpureFunction0(3, _c8));
  }
}
const LOCALSTATE_PREFIX = 'feature-highlight.dismissed.';
export let UiFeatureHighlightComponent = /*#__PURE__*/(() => {
  class UiFeatureHighlightComponent {
    set contentBg(color) {
      this._contentBg = color;
      this.updateBgColor();
    }
    constructor(localSettings, el, renderer, store, cd) {
      this.localSettings = localSettings;
      this.el = el;
      this.renderer = renderer;
      this.store = store;
      this.cd = cd;
      this.displayHighlight = false;
      this.dismissed = false;
      this.hideIfDismissed = false; // by default the component will not hide it's element, just it's style as there might be important ng-content inside!
      this.fillWrapper = false; // enable absolute positioning
      this.displayForDays = 90; // count of days after creationDate
      this.position = 'bottomright';
      this.showTransitionOptions = '225ms ease-out';
      this.hideTransitionOptions = '195ms ease-in';
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
    }
    ngOnInit() {
      if (this.creationDate) {
        const date = dayjs(this.creationDate);
        const timeout = date.add(this.displayForDays, 'day');
        if (timeout.isBefore(new Date())) {
          this.hideAll();
          return;
        }
      }
      this.loggedIn$.subscribe(loggedIn => {
        if (loggedIn) {
          const dismissed = this.store.selectSnapshot(LocalState.get(LOCALSTATE_PREFIX + this.highlightId, false));
          if (!dismissed) this.display();else this.dismissed = true;
          this.cd.markForCheck();
        } else {
          this.hideAll();
        }
      });
    }
    display() {
      this.displayHighlight = true;
      this.updateBgColor();
      if (this.borderRadius) {
        this.renderer.setStyle(this.wrapper.nativeElement, 'border-radius', this.borderRadius);
        this.renderer.setStyle(this.border.nativeElement, 'border-radius', this.borderRadius);
        this.renderer.setStyle(this.content.nativeElement, 'border-radius', this.borderRadius);
      }
      this.cd.markForCheck();
    }
    updateBgColor() {
      if (this._contentBg && this.content.nativeElement) this.renderer.setStyle(this.content.nativeElement, 'background', this._contentBg);
    }
    hideAll() {
      this.displayHighlight = false;
      this.dismissed = true;
      this.tooltipFeatureInfo?.hide();
      // this.unbindDocumentClickListener();
      this.cd.markForCheck();
    }
    dismiss() {
      this.hideAll();
      this.preventDocumentDefault = false;
      this.localSettings.set(LOCALSTATE_PREFIX + this.highlightId, true);
      this.cd.markForCheck();
    }
    getPreferredTooltipPosition() {
      switch (this.position) {
        case 'topright':
          return TooltipPlacements.TOPEND;
          break;
        case 'bottomright':
          return TooltipPlacements.BOTTOMEND;
          break;
        default:
          return this.position;
      }
    }
    static {
      this.ɵfac = function UiFeatureHighlightComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiFeatureHighlightComponent)(i0.ɵɵdirectiveInject(i1.LocalFacade), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiFeatureHighlightComponent,
        selectors: [["ui-feature-highlight"], ["", "uiFeatureHighlight", ""]],
        viewQuery: function UiFeatureHighlightComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ElementRef)(_c1, 7, ElementRef)(_c2, 7, ElementRef)(_c3, 5, ElementRef)(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.border = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.infoBox = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipFeatureInfo = _t.first);
          }
        },
        hostVars: 8,
        hostBindings: function UiFeatureHighlightComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("visible", ctx.displayHighlight)("dismissed", ctx.dismissed)("hide-when-dismissed", ctx.hideIfDismissed)("fill-wrapper", ctx.fillWrapper);
          }
        },
        inputs: {
          hideIfDismissed: "hideIfDismissed",
          fillWrapper: "fillWrapper",
          highlightId: "highlightId",
          contentBg: "contentBg",
          borderRadius: "borderRadius",
          infoText: "infoText",
          creationDate: "creationDate",
          displayForDays: "displayForDays",
          position: "position",
          showTransitionOptions: "showTransitionOptions",
          hideTransitionOptions: "hideTransitionOptions"
        },
        ngContentSelectors: _c5,
        decls: 13,
        vars: 8,
        consts: [["wrapper", ""], ["content", ""], ["border", ""], ["tooltipFeatureInfo", ""], [1, "wrapper"], [1, "content"], [1, "border"], [1, "badge", 3, "ngClass", "uiTooltipTrigger", "uiTooltipTriggerOptions"], ["theme", "contrast", 3, "uiTooltipOptions", "referenceObject"], ["uiButton", "", "label", "ausblenden", "icon", "check", 1, "ui-button-outline", "small", 3, "click"], ["icon", "info"]],
        template: function UiFeatureHighlightComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 4, 0)(2, "div", 5, 1);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "div", 6, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, UiFeatureHighlightComponent_Conditional_7_Template, 2, 4, "div", 7);
            i0.ɵɵelementStart(8, "ui-tooltip-content", 8, 3)(10, "p");
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "button", 9);
            i0.ɵɵlistener("click", function UiFeatureHighlightComponent_Template_button_click_12_listener() {
              return ctx.dismiss();
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const wrapper_r3 = i0.ɵɵreference(1);
            i0.ɵɵadvance(7);
            i0.ɵɵconditional(ctx.displayHighlight ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("uiTooltipOptions", i0.ɵɵpureFunction2(5, _c7, ctx.getPreferredTooltipPosition(), i0.ɵɵpureFunction0(4, _c6)))("referenceObject", wrapper_r3);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.infoText);
          }
        },
        dependencies: [CommonModule, i3.NgClass, UiButtonComponent, UiIconsModule, i4.UiIconComponent, i5.UiTooltipContentComponent, i6.UiTooltipTriggerDirective],
        styles: ["[_nghost-%COMP%]{--uiFeatureHlBaseColor: var(--contrastColor);--uiFeatureHlHoverColor: var(--contrastLightenedColor);--uiFeatureHlHlColor: #fcf3e0}.extra[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]:not(.dismissed)   .wrapper[_ngcontent-%COMP%]{padding:5px;background:transparent;position:relative}[_nghost-%COMP%]:not(.dismissed)   .border[_ngcontent-%COMP%]{background:transparent;overflow:hidden;position:absolute;inset:0;z-index:1}.visible[_nghost-%COMP%]{position:relative;display:block}.visible[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{background:var(--uiFeatureHlBaseColor);z-index:2;position:relative}.visible[_nghost-%COMP%]   .border[_ngcontent-%COMP%]:before{content:\"\";position:absolute;display:block;z-index:1;left:-100%;top:-200%;width:280%;height:700%;transform:rotate(-45deg);overflow:hidden;background:linear-gradient(to right,var(--uiFeatureHlBaseColor) 40%,var(--uiFeatureHlHlColor) 50%,var(--uiFeatureHlHlColor) 55%,var(--uiFeatureHlBaseColor) 70%);background-size:200% auto;animation:_ngcontent-%COMP%_shine 3s linear infinite}.visible[_nghost-%COMP%]   .badge[_ngcontent-%COMP%]{display:inline-block;position:absolute;background:var(--uiFeatureHlBaseColor);color:#fff;transition:background-color .2s;padding:0 9px;border-radius:20px;z-index:100;transition:opacity .2s;pointer-events:all}.visible[_nghost-%COMP%]   .badge[_ngcontent-%COMP%]:hover{cursor:pointer;background:var(--uiFeatureHlHoverColor)}.visible[_nghost-%COMP%]   .badge.position-left[_ngcontent-%COMP%]{right:calc(100% + 8px);top:calc(50% - 12px)}.visible[_nghost-%COMP%]   .badge.position-right[_ngcontent-%COMP%]{left:calc(100% + 8px);top:calc(50% - 12px)}.visible[_nghost-%COMP%]   .badge.position-top[_ngcontent-%COMP%]{bottom:calc(100% + 8px);left:calc(50% - 12px)}.visible[_nghost-%COMP%]   .badge.position-bottom[_ngcontent-%COMP%]{top:calc(100% + 8px);left:calc(50% - 12px)}.visible[_nghost-%COMP%]   .badge.position-topright[_ngcontent-%COMP%]{bottom:calc(100% - 12px);left:calc(100% - 12px)}.visible[_nghost-%COMP%]   .badge.position-bottomright[_ngcontent-%COMP%]{top:calc(100% - 12px);left:calc(100% - 12px)}.visible.infobox-visible[_nghost-%COMP%]   .badge[_ngcontent-%COMP%]{opacity:0}.dismissed.hide-when-dismissed[_nghost-%COMP%]{display:none!important}.fill-wrapper[_nghost-%COMP%]{position:absolute!important;inset:0;pointer-events:none}.fill-wrapper[_nghost-%COMP%]   .wrapper[_ngcontent-%COMP%]{position:absolute!important;inset:0}.fill-wrapper[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{position:absolute!important;inset:5px}[_nghost-%COMP%]    >ui-tooltip-content .tooltip{background:var(--uiFeatureHlBaseColor);width:360px;min-width:250px;border-radius:4px;z-index:100;pointer-events:all}[_nghost-%COMP%]    >ui-tooltip-content .tooltip button.ui-button{--buttonBorderColor:#fff!important;--buttonTextColor:#fff!important;--buttonIconColor:#fff!important}@keyframes _ngcontent-%COMP%_shine{to{background-position:200% center}}"],
        changeDetection: 0
      });
    }
  }
  return UiFeatureHighlightComponent;
})();